import '@babel/polyfill'
// PostCSS import and to compile styles
import styles from '/css/index.css'
import data from '/data/index.json'

import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import DOM from 'react-dom'
import App from '/js/views/app'
import whatInput from 'what-input'

const el = document.getElementById('root')

function render() {
  return DOM.render(
    <BrowserRouter>
      <App
        data={data}
        location={window.location}
        className="relative bg-white-smoke"
      />
    </BrowserRouter>,
    el
  )
}

render()
